<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-bct">
    <main class="tpl-bct__main">
      <header class="tpl-bct__header">
        <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-bct__logo" />
      </header>

      <div class="tpl-bct__segments" aria-hidden="true">
        <span
          v-for="n in Math.max(progress.total, 1)"
          :key="n"
          class="tpl-bct__segment"
          :class="{ 'tpl-bct__segment--active': isGate || n <= progress.current }"
        ></span>
      </div>

      <div v-if="showHero" class="tpl-bct__hero">
        <h1 class="tpl-bct__hero-title">{{ quiz.title }}</h1>
        <p v-if="quiz.sub_title" class="tpl-bct__hero-sub">{{ quiz.sub_title }}</p>
      </div>

      <slot />
    </main>

    <footer class="tpl-bct__footer">
      <div class="tpl-bct__footer-top">
        <img v-if="quiz.logo" :src="quiz.logo" alt="" class="tpl-bct__footer-logo" />
        <div class="tpl-bct__footer-links">
          <a v-if="quiz.privacy_url" :href="quiz.privacy_url" target="_blank">
            {{ quiz.privacy_text || 'Privacy Policy' }}
          </a>
        </div>
      </div>
      <p v-if="quiz.legal_name" class="tpl-bct__footer-legal">
        {{ quiz.legal_name }}<template v-if="quiz.legal_id"> — {{ quiz.legal_id }}</template>
      </p>
      <p v-if="quiz.disclaimer" class="tpl-bct__footer-disclaimer">{{ quiz.disclaimer }}</p>
    </footer>
  </div>
</template>
